export default "__VITE_ASSET__53df9ab4__"